import React from 'react';
import { Link } from 'react-router-dom';
import { CITY_GUIDES, topRated } from '../data/guide';
import { SHOP_PRODUCTS } from '../data/shop';
import { formatPrice } from '../data/smaken';
import { Reveal } from '../components/Reveal';
import { Rating } from '../components/Rating';
import { Discovered } from '../components/home/Discovered';
import { MapSection } from '../components/home/MapSection';
import { Magazine } from '../components/home/Magazine';
import { Note, ArrowMark } from '../components/Marks';
const topProducts = SHOP_PRODUCTS.filter(p => p.stamp).slice(0, 3);
export function Guide() {
  const best = topRated(4);
  return <div data-id="element-898" data-mp="mlg4i55weq8f">
      <div className="mx-auto max-w-page px-5 pb-14 pt-10 md:px-8 md:pt-14" data-id="element-899" data-mp="ml6c6axds6zk">
        <Reveal data-id="element-900" data-mp="hl0spi19lqsk">
          <p className="text-[11px] font-bold uppercase tracking-wide3 text-rod" data-id="element-901" data-mp="hmld4etv7tcp">Guiden</p>
          <h1 className="display-xl mt-3 text-[3rem] uppercase leading-[0.9] sm:text-[4.5rem]" data-id="element-902" data-mp="wff5v1y5e5zb">
            Vi vet var du ska äta.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-black/70" data-id="element-903" data-mp="1dlu386f1pd08">
            Ingen algoritm, inga sponsrade placeringar. Vi har varit på varje ställe och betalat för maten
            själva.
          </p>
        </Reveal>
      </div>

      {/* Cities */}
      <section aria-labelledby="stader" className="border-y border-black/12" data-id="element-904" data-mp="1rkts9f6gztwx">
        <div className="mx-auto max-w-page px-5 py-14 md:px-8 md:py-16" data-id="element-905" data-mp="1riqs42blskeh">
          <h2 id="stader" className="display-xl text-4xl uppercase sm:text-5xl" data-id="element-906" data-mp="1wj539t8i4agq">
            Vart är du på väg?
          </h2>

          <div className="mt-10 grid gap-x-8 gap-y-12 sm:grid-cols-2" data-id="element-907" data-mp="21gwrac60zcfn">
            {CITY_GUIDES.map((guide, i) => <Reveal key={guide.city} delay={Math.min(i * 0.06, 0.18)} data-id="element-908" data-mp="2abbgp7k9s3ch" data-mpi={i}>
                <Link to={`/guide/${guide.city.toLowerCase()}`} className="group block border-t-2 border-black pt-4" data-id="element-909" data-mp="2aajp07tsmprh">
                  <div className="aspect-[16/10] overflow-hidden bg-black/5" data-id="element-910" data-mp="2f8l6iobkmh0u">
                    <img src={guide.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-911" data-mp="2k9sfgqpg9m93" />
                  </div>
                  <h3 className="display-xl mt-4 text-3xl uppercase transition-colors duration-150 ease-out group-hover:text-rod sm:text-4xl" data-id="element-912" data-mp="tz5hh1mofmty">
                    {guide.city}
                  </h3>
                  <p className="mt-2 leading-relaxed text-black/65" data-id="element-913" data-mp="12ztw9yjw9r7w">{guide.strap}</p>
                </Link>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Our highest rated */}
      <section aria-labelledby="hogst" className="bg-black text-papper" data-id="element-914" data-mp="17wu3icshd00l">
        <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-915" data-mp="17ur4j39cnwjq">
          <Reveal data-id="element-916" data-mp="3eo35eh4q9z2p">
            <h2 id="hogst" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-917" data-mp="3epe5a5v1ymoj">
              Högst betyg just nu
            </h2>
            <Note className="mt-3 block text-smor" data-id="element-918" data-mp="1p6fze3sd31yf">Vår åsikt, inte deras.</Note>
          </Reveal>

          <ul className="mt-12 divide-y divide-papper/20 border-y border-papper/20" data-id="element-919" data-mp="1u4zjrzrb45oo">
            {best.map(({
            place,
            verdict
          }, i) => <Reveal key={place.slug} delay={Math.min(i * 0.05, 0.15)} data-id="element-920" data-mp="1fflccx7ajybx" data-mpi={i}>
                <li data-id="element-921" data-mp="1kexz7hy5x5ei">
                  <Link to={`/plats/${place.slug}`} className="group grid items-center gap-5 py-6 sm:grid-cols-[6rem,minmax(0,1fr),auto]" data-id="element-922" data-mp="1ke4xive29638">
                    <img src={place.image} alt="" loading="lazy" className="hidden h-24 w-24 object-cover sm:block" data-id="element-923" data-mp="1bfj7yga68qsy" />
                    <div data-id="element-924" data-mp="11gtx37gp06m7">
                      <p className="font-display text-2xl uppercase transition-colors duration-150 ease-out group-hover:text-smor" data-id="element-925" data-mp="2qvi9v9t73qkr">
                        {place.name}
                      </p>
                      <p className="mt-1 text-[11px] font-bold uppercase tracking-wide2 text-papper/50" data-id="element-926" data-mp="vsd7w9hg7fqk">
                        {place.city} · {place.tags.join(' · ')}
                      </p>
                      <p className="mt-2 max-w-xl leading-relaxed text-papper/75" data-id="element-927" data-mp="roxavc1gvddc">{verdict.verdict}</p>
                      <p className="mt-2 font-hand text-xl text-smor" data-id="element-928" data-mp="hsknevwilvr1">Beställ: {verdict.order}</p>
                    </div>
                    <span className="inline-flex items-center gap-1.5 justify-self-start sm:justify-self-end" data-id="element-929" data-mp="cu10ota3kfxm">
                      <span className="display-xl text-4xl text-smor" data-id="element-930" data-mp="81pz7lzpkm2y">
                        {verdict.rating.toString().replace('.', ',')}
                      </span>
                      <span className="text-[11px] uppercase tracking-wide2 text-papper/45" data-id="element-931" data-mp="3v7qofou8w27i">/ 5</span>
                    </span>
                  </Link>
                </li>
              </Reveal>)}
          </ul>
        </div>
      </section>

      {/* Top products */}
      <section aria-labelledby="toppprodukter" className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-932" data-mp="3lbnbrp1rol6b">
        <Reveal data-id="element-933" data-mp="3b7qiwqssoine">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-934" data-mp="3g476njw30uzy">
            <div data-id="element-935" data-mp="3g6a5mtf7pygt">
              <h2 id="toppprodukter" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-936" data-mp="3l3thxnsco164">
                Topplistan
              </h2>
              <Note className="mt-3 block" data-id="element-937" data-mp="3q1btzn1nywic">Det vi köper själva, om och om igen.</Note>
            </div>
            <Link to="/butik" className="group flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out hover:text-rod" data-id="element-938" data-mp="2sg7hgoef5cnh">
              Handla allt
              <ArrowMark className="h-4 w-9 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-939" data-mp="373sfi3wfsloj" />
            </Link>
          </div>
        </Reveal>

        <ol className="mt-12 grid gap-x-8 gap-y-12 sm:grid-cols-3" data-id="element-940" data-mp="29nvblrok3t8l">
          {topProducts.map((product, i) => <Reveal key={product.id} delay={Math.min(i * 0.06, 0.18)} data-id="element-941" data-mp="2eldcqvwc1461" data-mpi={i}>
              <li className="border-t-2 border-black pt-4" data-id="element-942" data-mp="26lh2txa6ljx1">
                <span className="display-xl block text-5xl text-rod" data-id="element-943" data-mp="21o8lu00rrlxd">0{i + 1}</span>
                <Link to="/butik" className="group mt-4 block" data-id="element-944" data-mp="2gclhswzux4rv">
                  <div className="aspect-[4/3] overflow-hidden bg-black/5" data-id="element-945" data-mp="2gbtmlna69924">
                    <img src={product.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-946" data-mp="2betgxdh8i8bj" />
                  </div>
                  <h3 className="mt-4 font-display text-2xl leading-tight" data-id="element-947" data-mp="1xnopuzrxmoct">{product.name}</h3>
                </Link>
                <p className="mt-1 text-[11px] font-bold uppercase tracking-wide2 text-black/45" data-id="element-948" data-mp="1slpmvr03ttge">
                  {product.producer} · {formatPrice(product.price)}
                </p>
                <Note className="mt-2 block !text-lg" data-id="element-949" data-mp="341nwpx33wjio">{product.tip}</Note>
              </li>
            </Reveal>)}
        </ol>

        <Reveal data-id="element-950" data-mp="3gks1a62f7tyl">
          <p className="mt-14 flex items-center gap-3 text-[12px] font-bold uppercase tracking-wide2" data-id="element-951" data-mp="3glb6qnavwpvq">
            <Rating value={4.5} data-id="element-952" data-mp="32limnatv57wq" />
            <span className="text-black/50" data-id="element-953" data-mp="32ml8v5g8qm6b">Så här sätter vi betyg: vi äter, vi betalar, vi tycker.</span>
          </p>
        </Reveal>
      </section>

      <Discovered data-id="element-954" data-mp="3ucgbu4x0uadg" />
      <MapSection data-id="element-955" data-mp="3ubwscjrq3dxb" />
      <Magazine data-id="element-956" data-mp="3udhlc4ye2ot2" />
    </div>;
}